import type {
  Prediction,
  BabyResult,
  LeaderboardResponse,
  StatsResponse,
} from '../types'

const BASE = '/api'

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: `Erreur ${res.status}` }))
    throw new Error((err as { error?: string }).error ?? `Erreur ${res.status}`)
  }
  return res.json()
}

export async function getStats(): Promise<StatsResponse> {
  const res = await fetch(`${BASE}/stats`)
  return handleResponse(res)
}

export async function getResults(): Promise<BabyResult | null> {
  const res = await fetch(`${BASE}/results`)
  return handleResponse(res)
}

export async function getLeaderboard(): Promise<LeaderboardResponse> {
  const res = await fetch(`${BASE}/leaderboard`)
  return handleResponse(res)
}

export async function adminGetPredictions(password: string): Promise<Prediction[]> {
  const res = await fetch(`${BASE}/predictions`, {
    headers: { 'X-Admin-Password': password },
  })
  return handleResponse(res)
}

export async function adminDeletePrediction(id: string, password: string): Promise<void> {
  const res = await fetch(`${BASE}/predictions/${id}`, {
    method: 'DELETE',
    headers: { 'X-Admin-Password': password },
  })
  return handleResponse(res)
}

export async function adminResendConfirmation(id: string, password: string): Promise<void> {
  const res = await fetch(`${BASE}/predictions/${id}/resend`, {
    method: 'POST',
    headers: { 'X-Admin-Password': password },
  })
  return handleResponse(res)
}

export async function adminDeleteAllPredictions(password: string): Promise<{ deleted: number }> {
  const res = await fetch(`${BASE}/predictions`, {
    method: 'DELETE',
    headers: { 'X-Admin-Password': password },
  })
  return handleResponse(res)
}

export async function adminDeleteResults(password: string): Promise<void> {
  const res = await fetch(`${BASE}/results`, {
    method: 'DELETE',
    headers: { 'X-Admin-Password': password },
  })
  return handleResponse(res)
}

export async function adminNotifyParticipants(ids: string[], password: string): Promise<{ sent: number; errors: number }> {
  const res = await fetch(`${BASE}/notify`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Admin-Password': password,
    },
    body: JSON.stringify({ ids }),
  })
  return handleResponse(res)
}

export async function adminTestResultEmail(
  password: string,
  preview?: { baby_name: string; baby_weight: number; arrival_date: string }
): Promise<{ success: boolean }> {
  const res = await fetch(`${BASE}/notify/test`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Admin-Password': password },
    body: JSON.stringify(preview ?? {}),
  })
  return handleResponse(res)
}

export async function adminSetResults(
  data: { baby_name: string; baby_weight: number; arrival_date: string },
  password: string
): Promise<void> {
  const res = await fetch(`${BASE}/results`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-Admin-Password': password,
    },
    body: JSON.stringify({
      ...data,
      baby_weight: Math.round(data.baby_weight * 1000),
    }),
  })
  return handleResponse(res)
}
